import { BeamtenKennung, BeruflicheStellung } from '@ps20/bff-models';

export interface SelbststaendigkeitsArt {
  selbststaendig: boolean;
  geschaeftsfuehrer: boolean;
}

export function getBeruflicheStellung(
  selbststaendigkeit: SelbststaendigkeitsArt,
): BeruflicheStellung {
  if (selbststaendigkeit.selbststaendig) {
    return BeruflicheStellung.SELBSTAENDIG;
  }
  return BeruflicheStellung.ANGESTELLTER;
}

export function getBeamtenKennung(imOeffentlichenDienstTaetig: boolean): BeamtenKennung {
  if (imOeffentlichenDienstTaetig === true) {
    return BeamtenKennung.BEAMTER;
  }
  return BeamtenKennung.NICHT_BEAMTER;
}
